import React from 'react';

const IconPremiumDelivery = ({
  className = '',
  color = '#27919C',
  height = '34',
  width = '34',
}) => (
  <svg
    viewBox="0 0 500 500"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width={width}
    height={height}
    className={className}
  >
    <g>
      <polyline
        stroke={color}
        fill="none"
        strokeLinejoin="round"
        strokeWidth="15px"
        points="135.9 220.18 175.55 182.37 135.9 144.56"
      />
      <line
        stroke={color}
        fill="none"
        strokeLinejoin="round"
        strokeWidth="15px"
        x1="175.55"
        y1="182.37"
        x2="100.48"
        y2="182.37"
      />
    </g>
    <rect
      stroke={color}
      fill="none"
      strokeLinejoin="round"
      strokeWidth="15px"
      x="100.48"
      y="270.67"
      width="141.64"
      height="113.29"
    />
    <polygon
      stroke={color}
      fill="none"
      strokeLinejoin="round"
      strokeWidth="15px"
      points="399.52 367.34 243.9 389.7 243.9 110.3 399.52 132.66 399.52 367.34"
    />
    <ellipse fill={color} cx="275.77" cy="250.76" rx="11.55" ry="11.63" />
    <rect
      stroke={color}
      fill="none"
      strokeLinejoin="round"
      strokeWidth="15px"
      x="159.22"
      y="270.67"
      width="24.14"
      height="39.11"
    />
    <path
      fill={color}
      d="M205,110.3c-3.14,0-5.68,2.56-5.68,5.73v154.64h42.8l1.79-160.36h-38.9Z"
    />
  </svg>
);

export default IconPremiumDelivery;
